import { Controller } from "@hotwired/stimulus"

// This controller is used to manage the combined job openings filter
// which includes: currently_hiring, job_titles_include, job_titles_exclude, job_departments, job_posted_date, open_jobs_count_from, open_jobs_count_to, include_closed_roles
export default class extends Controller {
  static values = {
    context: { type: String, default: "" },
  }

  clear() {
    // Dispatch filter event to clear all job-related parameters
    const filters = [
      { name: "currently_hiring", values: [] },
      { name: "job_titles_include", values: [] },
      { name: "job_titles_exclude", values: [] },
      { name: "job_departments", values: [] },
      { name: "job_posted_date", values: [] },
      { name: "open_jobs_count_from", values: [] },
      { name: "open_jobs_count_to", values: [] },
      { name: "include_closed_roles", values: [] },
    ]

    this.dispatch("filter", { detail: { filters: filters, context: this.contextValue } })
  }
}
